import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../instance";

const url = process.env.REACT_APP_API_BASE_URL;

const initialState = {
  fldLoading: false,
  folders: [],
  personnelFolders: [],
  folderObj: {},
  otherFolders: [],
  deleteLoading: false,
  personnelCount: 0,
  singlePersonnel: {},
  refetch: false,
  refetchKey: "",
  wefObj:{},
  staffObj:{},
  casualObj:{},
  attendanceObj:{},
  casualPaymentObj:{},
  singlePaymentObj:{},
  attendanceHeaderObj:{},
  directHeaderObj:{},
};

export const fetchPersonnelFolders = createAsyncThunk(
  "folderSlice/fetchPersonnelFolders",
  async (data) => {
    const res = await axiosInstance.get(
      `${url}/hr/fetchPersonnel.action?limit=${data?.limit ?? ''}&start=${
        data?.start ?? 0
      }&criteria=${data?.criteria}&txtSearch=${data?.txtSearch}`
    );
    return res.data;
  }
);

export const fetchSinglePersonnel = createAsyncThunk(
  "folderSlice/fetchSinglePersonnel",
  async (data) => {
    const res = await axiosInstance.get(
      `${url}/hr/fetchPersonnel.action?criteria=${data?.criteria}&txtSearch=${data?.txtSearch}`
    );
    return res.data?.data?.result;
  }
);

export const deleteGroup = createAsyncThunk(
  "graduate/deleteGroup",
  async (id) => {
    const res = await axiosInstance.delete(`${url}/api/v2/groups/${id}`);
    return res?.data;
  }
);

export const folderSlice = createSlice({
  name: "folder",
  initialState,
  reducers: {
    setFolderObj: (state, action) => {
      state.folderObj = action.payload;
    },

    folderCleanUp: (state) => {
      state.folderObj = {};
    },

    setRefetch: (state) => {
      state.refetch = !state.refetch;
    },
    setRefetchKey: (state, action) => {
      state.refetchKey = action.payload;
    },
    setWefObj: (state, action) => {
      state.wefObj = action.payload;
    },
    setStaffObj: (state, action) => {
      state.staffObj = action.payload;
    },
    wefleanUp: (state) => {
      state.wefObj = {};
    },
    setCasualObj: (state, action) => {
      state.casualObj = action.payload;
    },
    setAttendanceObj: (state, action) => {
      state.attendanceObj = action.payload;
    },
    setCasualPaymentObj: (state, action) => {
      state.casualPaymentObj = action.payload;
    }, 
    
    casualCleanUp: (state) => {
      state.casualObj = {};
    },
    
    cleanCasualPaymentObj: (state) => {
      state.casualPaymentObj = {};
    }, 

    cleanPersonnelRequest: (state) => {
      state.refetchKey = initialState.refetchKey;
    },

    setSinglePaymentObj: (state, action) => {
      state.singlePaymentObj = action.payload;
    },  
    cleanSinglePaymentObj: (state) => {
      state.singlePaymentObj = {};
    },

    setAttendanceHeaderObj: (state, action) => {
      state.attendanceHeaderObj = action.payload;
    },  
    cleanAttendanceHeaderObj: (state) => {
      state.attendanceHeaderObj = {};
    },

    setDirectHeaderObj: (state, action) => {
      state.directHeaderObj = action.payload;
    }, 
    
   cleanDirectHeaderObj: (state) => {
      state.directHeaderObj = {};
    },
    clearFolderObj: () => {
      return { ...initialState };
    },
   

    
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchPersonnelFolders.pending, (state) => {
        state.fldLoading = true;
      })
      .addCase(fetchPersonnelFolders.fulfilled, (state, action) => {
        state.fldLoading = false;
        state.personnelFolders = action?.payload?.data?.result;
        state.personnelCount = action?.payload?.data?.total;
      })
      .addCase(fetchPersonnelFolders.rejected, (state) => {
        state.fldLoading = false;
        state.personnelFolders = [];
        state.personnelCount = 0;
      })

      .addCase(fetchSinglePersonnel.pending, (state) => {
        state.fldLoading = true;
      })
      .addCase(fetchSinglePersonnel.fulfilled, (state, action) => {
        state.fldLoading = false;
        state.singlePersonnel = action?.payload;
      })
      .addCase(fetchSinglePersonnel.rejected, (state) => {
        state.fldLoading = false;
        state.singlePersonnel = {};
      })

      .addCase(deleteGroup.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteGroup.fulfilled, (state, action) => {
        state.deleteLoading = false;
      })
      .addCase(deleteGroup.rejected, (state) => {
        state.deleteLoading = false;
      });
  },
});

export default folderSlice.reducer;
export const {
  setFolderObj,
  folderCleanUp,
  setRefetch,
  setRefetchKey,
  cleanProductRequest,
  setWefObj,
  wefleanUp,
  setStaffObj,
  setCasualObj,
  casualCleanUp,
  setAttendanceObj,
  setCasualPaymentObj,
  cleanCasualPaymentObj,
  setSinglePaymentObj,
  cleanSinglePaymentObj,
  setAttendanceHeaderObj,
  cleanAttendanceHeaderObj,
  setDirectHeaderObj,cleanDirectHeaderObj,
  clearFolderObj
} = folderSlice.actions;

 